// A ordem das paradas do dia. Fica no localStorage por dia da semana e NAO
// sincroniza: e preferencia do aparelho, nao dado do negocio -- dois celulares
// do mesmo representante podem querer ordens diferentes, e um dado destes
// subindo pela outbox so gastaria fila.
//
// Mora aqui, e nao dentro da AgendaDia, porque componente com hook nao e
// testavel neste projeto (vitest em environment 'node', sem DOM). Dentro da
// tela, trocar um sinal na comparacao ou perder o dia na chave nao quebraria
// teste nenhum -- e o representante veria a rota fora de ordem sem entender.

const PREFIXO = 'ordem-agenda-'

export function chaveOrdem(diaSemana: number): string {
  return `${PREFIXO}${diaSemana}`
}

export function lerOrdem(diaSemana: number): string[] {
  try {
    const bruto = localStorage.getItem(chaveOrdem(diaSemana))
    const lido: unknown = bruto ? JSON.parse(bruto) : []
    // Array.isArray e a guarda que importa: um valor gravado torto por versao
    // antiga (objeto, numero, texto) passaria adiante e o indexOf explodiria na
    // hora de ordenar -- a agenda do dia abriria em branco, na rua, sem recurso.
    return Array.isArray(lido) ? lido.filter((id): id is string => typeof id === 'string') : []
  } catch {
    // localStorage bloqueado pelo navegador ou JSON corrompido: a rota sai na
    // ordem alfabetica, que e util. Nunca derruba a tela.
    return []
  }
}

export function gravarOrdem(diaSemana: number, ids: string[]): void {
  try {
    localStorage.setItem(chaveOrdem(diaSemana), JSON.stringify(ids))
  } catch {
    // Cota estourada ou modo privado: perder a preferencia de ordem e aceitavel,
    // perder o check-in nao seria -- mas check-in nao passa por aqui.
  }
}

type Ordenavel = { id: string; razao_social: string }

// Quem esta na preferencia sai na ordem escolhida; quem NAO esta sai depois,
// em ordem alfabetica. O "depois" e a regra que mais importa: cliente novo na
// rota chega com indexOf === -1, e -1 e o menor de todos os numeros da lista --
// sem o tratamento explicito ele furaria a fila e apareceria em primeiro.
export function ordenarPorPreferencia<T extends Ordenavel>(itens: readonly T[], ordem: readonly string[]): T[] {
  return [...itens].sort((a, b) => {
    const ia = ordem.indexOf(a.id)
    const ib = ordem.indexOf(b.id)
    if (ia === -1 && ib === -1) return a.razao_social.localeCompare(b.razao_social)
    if (ia === -1) return 1
    if (ib === -1) return -1
    return ia - ib
  })
}

// Troca o cliente de lugar com o vizinho. Devolve null quando nao ha para onde
// ir (topo com a seta de subir, fim com a de descer), para a tela saber que nao
// ha nada a gravar em vez de regravar a mesma lista.
export function moverNaLista(ids: readonly string[], clienteId: string, direcao: -1 | 1): string[] | null {
  const indice = ids.indexOf(clienteId)
  if (indice === -1) return null
  const destino = indice + direcao
  if (destino < 0 || destino >= ids.length) return null
  const copia = [...ids]
  ;[copia[indice], copia[destino]] = [copia[destino], copia[indice]]
  return copia
}

// Move um item de uma posicao para outra, deslizando quem esta no meio.
//
// ⚠ NAO e a mesma coisa que moverNaLista, que TROCA com o vizinho e serve as
// setas. Arrastar 'a' da posicao 0 para a 3 tem de dar ['b','c','d','a']; uma
// troca daria ['d','b','c','a'], que e o que o dedo NAO pediu. As duas
// operacoes ficam, cada uma servindo o seu gesto.
export function reordenar(ids: readonly string[], de: number, para: number): string[] {
  const copia = [...ids]
  // Indice fora da lista: devolve igual em vez de estourar. O dnd-kit chama com
  // -1 quando o card e solto fora de qualquer alvo valido.
  if (de < 0 || de >= copia.length || para < 0 || para >= copia.length) return copia
  const [item] = copia.splice(de, 1)
  copia.splice(para, 0, item)
  return copia
}
